import { IStandardMultipleAutocomplete } from "../../_common/interface/autocomplete/iMultipleAutocomplete";
import { formFieldKeyLookupService } from "../../_services/formFieldKeyLookup.service";
import { MultipleAutoComplete } from "./multiple.autocomplete";

interface IMultipleExtAutocomplete extends IStandardMultipleAutocomplete {
}

export const FormFieldKeyLookupMultipleAutoComplete = (params: IMultipleExtAutocomplete) => {

    return (
        <MultipleAutoComplete
            {...params}
            itemsLoader={() => { return formFieldKeyLookupService.dropdown(Number(params.parentId)); }}
            label={"Form Field Key Lookup Dependency"} />
    );
}